export default {
	updateConnectInvoices(state, res) {
		if (res && res.Data) {
			state.ConnectInvoices = [...res.Data];
			// state.ConnectInvoicesTotal = res.Total;
			state.TaxCodeCQT = res.TaxCode;
		} else {
			state.ConnectInvoices = [];
			state.ConnectInvoicesTotal = 0;
		}
	},
	/**
	 * Hàm cập nhật danh sách lịch sử CQT
	 * @param {*} state
	 * @param {*} res
	 */
	updateConnectInvoicesTaxaxion(state, res) {
		if (res && res.Data) {
			state.ConnectInvoicesTaxaxion = [...res.Data];
			state.TaxCodeCQT = res.TaxCode;
		} else {
			state.ConnectInvoicesTaxaxion = [];
			state.ConnectInvoicesTaxaxionTotal = 0;
		}
	},

	/**
	 * Hàm reset Lịch sử tải HĐ đầu ra và đầu vào
	 * @param {*} state
	 */
	resetDataConnectInvoiceAndOutInvoice(state) {
		//Lịch sử tải HĐ đầu vào
		state.ConnectOutInvoices = [];
		state.ConnectOutInvoicesTotal = 0;
		//Lịch sử tải HĐ đầu ra
		state.ConnectInvoicesTaxaxion = [];
		state.ConnectInvoicesTaxaxionTotal = 0;
	},

	updateInvoicesAutoLoad(state, res) {
		if (res) {
			state.InvoicesAutoLoad = [...res];
		} else {
			state.InvoicesAutoLoad = [];
		}
	},

	updateConnectOutputInvoices(state, res) {
		if (res.Data) {
			state.ConnectOutInvoices = [...res.Data];
			// state.ConnectOutInvoicesTotal = res.Total;
			state.TaxCodeCQT = res.TaxCode;
		} else {
			state.ConnectOutInvoices = [];
			state.ConnectOutInvoicesTotal = 0;
		}
	},

	updateOutInvoicesAutoLoad(state, res) {
		if (res) {
			state.OutInvoicesAutoLoad = [...res];
		} else {
			state.OutInvoicesAutoLoad = [];
		}
	},

	updateDataConnectTaxaxion(state, res) {
		state.DataConnectTaxaxion = res;
	},

	updateDataConnectSupplier(state, res) {
		state.DataConnectSupplier = res;
	},

	updateLoadingTotalRecords(state, res) {
		state.IsLoadingTotalRecords = res;
	},
	updateLoadingTotalTypeInvoice(state, res) {
		state.IsLoadingTotalTypeInvoice = res;
	},
	updateTotalTypeInvoice(state, res) {
		state.TotalTypeInvoiceAutoLoad = res;
	},
	updateNumberInvoiceAutoRespone(state, res) {
		state.NumberInvoiceAutoRespone = res;
	},
	updateConnectInvoiceDetails(state, res) {
		state.ConnectInvoiceDetails = res;
	},
	updateConnectOutInvoiceDetails(state, res) {
		state.ConnectOutInvoiceDetails = res;
	},
	updateTotalStatusInvoice(state, res) {
		state.TotalStatusInvoice = res;
	},
	updateTotalStatusOutInvoice(state, res) {
		state.TotalStatusOutInvoice = res;
	},
	updateLoadingTotalInvoiceStatus(state, res) {
		state.IsLoadingTotalInvoiceStatus = res;
	},
	updateTimeServerRemind(state, res) {
		state.TimeServerRemind = res;
	},
	updateTotalInvoiceStatus(state, res) {
		if (!res) return;
		if (res.IsInbot) {
			state.TotalInvoiceStatus = res;
		} else {
			state.TotalOutInvoiceStatus = res;
		}
	},
	resetDataDefault(state, res) {
		state.ConnectInvoiceDetails = [];
		state.ConnectOutInvoiceDetails = [];
		state.TotalInvoiceStatus = {
			All: 0,
			Success: 0,
			Fail: 0,
			Processed: 0,
			Processing: 0,
			Duplicated: 0,
			Ignore: 0
		};
		state.TotalOutInvoiceStatus = {
			All: 0,
			Success: 0,
			Fail: 0,
			Processed: 0,
			Processing: 0,
			Duplicated: 0,
			Ignore: 0
		};
	},
	/**
	 * Hàm update trạng thái mở của form mất kết nối với cơ quan thuế
	 * @param {*} state
	 * @param {*} res
	 * @author hvanh - 29.1.2024
	 */
	updateActionDisconnectTaxaxion(state, res) {
		state.isShowFormDisconnectActive = res;
	},
	/**
	 * Hàm update trạng thái mở của form kết nối với cơ quan thuế
	 * @param {*} state
	 * @param {*} res
	 * @author hvanh - 29.1.2024
	 */
	updateActionConnectTaxaxion(state, res) {
		state.isShowFormConnectActive = res;
	},

	updateIsLoadingTotalRecordsInbot(state, res) {
		state.IsLoadingTotalRecordsInbot = res;
	},
	updateConnectInvoicesTotal(state, res) {
		state.ConnectInvoicesTotal = res;
	},
	updateConnectInvoicesTaxaxionTotal(state, res) {
		state.ConnectInvoicesTaxaxionTotal = res;
	},
	updateIsLoadingTotalRecordsOutbot(state, res) {
		state.IsLoadingTotalRecordsOutbot = res;
	},
	updateConnectOutInvoicesTotal(state, res) {
		state.ConnectOutInvoicesTotal = res;
	},
	/**
	 * Cập nhật danh sách hóa đơn đang tải.
	 * Tổng số bản ghi cập nhật riêng qua updateInvoiceLoadingTotal.
	 * PBI 625836 — tab "Hóa đơn đang tải".
	 */
	updateInvoiceLoadingList(state, res) {
		if (res && res.Data) {
			state.InvoiceLoadingList = [...(res.Data.Data || [])];
		} else {
			state.InvoiceLoadingList = [];
		}
	},
	updateInvoiceLoadingTotal(state, res) {
		state.InvoiceLoadingTotal = res || 0;
	},
	updateIsLoadingInvoiceLoading(state, res) {
		state.IsLoadingInvoiceLoading = res;
	},
	resetInvoiceLoadingList(state) {
		state.InvoiceLoadingList = [];
		state.InvoiceLoadingTotal = 0;
		state.IsLoadingInvoiceLoading = false;
	},
	updateOutInvoicePendingList(state, res) {
		state.OutInvoiceLoadingList = res && res.Data ? [...(res.Data.Data || [])] : [];
	},
	updateOutInvoicePendingTotal(state, res) {
		state.OutInvoiceLoadingTotal = res && res.Success ? res.Data : 0;
	},
	updateIsLoadingOutInvoicePending(state, isLoading) {
		state.IsLoadingOutInvoiceLoading = isLoading;
	},
	resetOutInvoicePendingList(state) {
		state.OutInvoiceLoadingList = [];
		state.OutInvoiceLoadingTotal = 0;
		state.IsLoadingOutInvoiceLoading = false;
	}
};
